<template>
    <div id="ssq" class="w1200">
        <div class="title">
            <span>大乐透-频道</span>
            <div>
                <!-- <a href="https://caipiao.ip138.com/daletou/"><span>大乐透走势图/工具</span></a> -->
                <a target="_blank" href="https://www.lottery.gov.cn/spqb/index.html"><span>大乐透开奖直播</span></a>
                <a target="_blank" href="https://www.lottery.gov.cn/dlt/"><span>大乐透开奖公告</span></a>
                <span @click="$router.push('/ssddt?type=dlt')">缩水单大厅</span>
                <span>十大缩水学霸排行</span>
                <a target="_blank" href="http://bbs.36886.net/forum.php?mod=forumdisplay&fid=8"><span>天云专区</span></a>
                <span @click="$router.push('/suoshuiruanjian');$vuex('vuex_menuActiveIndex', 5)">大乐透缩水软件</span>
            </div>
        </div>
        <div class="one">
            <div class="left">
                <ranking :rankingArr="rankingArr" lotteryType="1" />
            </div>
            <div class="right">
                <div class="left">
                    <forecast lotteryType="1" />
                </div>
                <div class="right">
                    <tezheng lotteryType="1" />
                </div>
            </div>
        </div>

        <div class="two">
            <div class="left">
                <zhuanqu lotteryType="1" />
            </div>
            <div class="right">
                <dltkaijiang />
            </div>
        </div>
    </div>
</template>

<script>
import ranking from "./components/ranking.vue";   //排名
import forecast from "./components/forecast.vue";   //预测
import zhuanqu from "./components/zhuanqu.vue";     //专区
import dltkaijiang from "./components/kaijiang/dlt.vue";   //开奖
import tezheng from "./components/tezheng.vue";
export default {
    components: {
        ranking,
        forecast,
        zhuanqu,
        dltkaijiang,
        tezheng,
    },
    data () {
        return {
            rankingArr: [
                "27-29.9万",
                "24-26.9万",
                "15-17.9万",
                "3-5.9万",
                "1-1.9万",
                "4368注↓",
                "杀5后",
                "围3后",
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/commonStyle.scss';
#ssq {
    margin-top: 20px;
    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: $theme_color;
        // background-image: linear-gradient(to right,#8FB3DA,);
        padding: 0px 20px;
        padding-left: 0;
        > span {
            font-weight: bold;
            font-size: 28px;
            height: 60px;
            line-height: 60px;
            background-color: #fff;
            padding: 0 20px;
        }
        > div {
            color: #ffffff;
            font-weight: bold;
            > span,
            a {
                margin: 0 10px;
                display: inline-block;
                cursor: pointer;
                position: relative;
                transition: transform 0.5s linear, font-weight 0.5s linear;
                &:hover {
                    transform: scale(1.2);
                    font-weight: bold;
                    &::after {
                        width: 100%;
                        left: 0%;
                    }
                }
                &:not(:hover) {
                    transform: scale(1);
                    font-weight: inherit;
                    &::after {
                        width: 0%;
                        left: 50%;
                    }
                }
                &::after {
                    content: '';
                    display: block;
                    border-bottom: 3px solid #fff;
                    width: 0%;
                    position: absolute;
                    left: 50%;
                    bottom: -5px;
                    transition: width 0.5s linear, left 0.5s linear;
                }
            }
        }
    }
    .one {
        margin-top: 20px;
        display: flex;
        > div {
            &.left {
                flex: 1;
            }
            &.right {
                flex: 2;
                margin-left: 20px;
                display: flex;
                > div {
                    &.left {
                        flex: 2;
                        border-right: 1px solid rgba(0, 0, 0, 0.07);
                    }
                    &.right {
                        flex: 1.3;
                        margin-left: 20px;
                    }
                }
            }
        }
    }
    .two {
        margin-top: 20px;
        display: flex;
        > div {
            // border: 1px solid red;
            &.left {
                flex: 1.5;
            }
            &.right {
                flex: 1;
            }
        }
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效，与 .w1200 容器自适应保持一致） ===== */
@media (max-width: 1200px) {
    // 频道标题改为竖排：标题文字一行，下面的链接另起一行并左对齐
    #ssq {
        .title {
            flex-direction: column;
            align-items: flex-start;

            // 链接行上下留点间距
            >div {
                padding: 10px 0;
            }
        }

        // 移动端：右侧区块去掉左边距与内部横向 flex，
        // 让 forecast / tezheng 竖向堆叠、完整可见，不超出屏幕
        // 注意：必须显式覆盖基础样式的 margin-left / display，仅注释掉不会生效
        .one {
            > div {
                &.right {
                    flex: 2;
                    margin-left: 0; // 覆盖基础样式的 margin-left: 20px
                    display: block; // 覆盖基础样式的 display: flex，子块改为竖向堆叠

                    // 内层子块：竖排后去掉分界线与左边距
                    > div {
                        &.left {
                            border-right: none; // 竖排后不再需要左右分界线
                        }

                        &.right {
                            margin-left: 0; // 覆盖基础样式的 margin-left: 20px
                        }
                    }
                }
            }
        }
    }
}
</style>